import script from "./PointButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./PointButton.vue?vue&type=script&setup=true&lang=ts"

import "./PointButton.vue?vue&type=style&index=0&id=14f9f01e&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14f9f01e"]])

export default __exports__